<form [formGroup]="form" class="formPhone w-100 fadeIn" autocomplete="off">
  <p class="text-center">
    {{ 'k002529' | translate }}
    <span class="blue2"> {{ phoneNumber }}</span>
    <!-- Token: We have just sent you an SMS with a confirmation code to your phone -->
  </p>
  <div class="contentinput">
    <mat-form-field class="mr-2">
      <input
        autocomplete="off"
        type="number"
        matInput
        id="code01"
        #code01
        name="code01"
        formControlName="code01"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 1)"
        (paste)="pastecode($event)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="mr-2">
      <input
        autocomplete="nothing"
        type="number"
        matInput
        id="code02"
        #code02
        name="code02"
        formControlName="code02"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 2)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="mr-2">
      <input
        autocomplete="nothing"
        type="number"
        matInput
        id="code03"
        #code03
        name="code03"
        formControlName="code03"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 3)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="mr-2">
      <input
        autocomplete="nothing"
        type="number"
        matInput
        id="code04"
        #code04
        name="code04"
        formControlName="code04"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 4)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="mr-2">
      <input
        autocomplete="nothing"
        type="number"
        matInput
        id="code05"
        #code05
        name="code05"
        formControlName="code05"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 5)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="mr-2">
      <input
        autocomplete="nothing"
        type="number"
        matInput
        id="code06"
        #code06
        name="code06"
        formControlName="code06"
        class="inp-item"
        onKeyPress="if(this.value.length==1) return false;"
        max="9"
        pattern="\d*"
        maxlength="1"
        (keyup)="keyupcode($event, 6)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
  </div>
  <small class="blue2 text-center"
    >{{ 'k002476' | translate }}
    <!-- Token: Once confirmed you can continue with the registration of your account. If you have not received a code -->
    <a class="clickHere" (click)="resendsms()">{{
      'k001645' | translate
    }}</a></small
  >
  <!-- Token: Click here -->
</form>
